import { render, staticRenderFns } from "./SplitJobContentCreate.vue?vue&type=template&id=1706e68b&scoped=true"
import script from "./SplitJobContentCreate.vue?vue&type=script&lang=js"
export * from "./SplitJobContentCreate.vue?vue&type=script&lang=js"
import style0 from "./SplitJobContentCreate.vue?vue&type=style&index=0&id=1706e68b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1706e68b",
  null
  
)

export default component.exports